import {useEffect, useState} from "react";
import {API_URL} from "../api/RequestConstants";

const useArticles = () => {
    const [articles, setArticles] = useState([]);

    useEffect(() => {
        const fetchArticlesFromAPI = async () => {
            try {
                const response = await fetch(API_URL + "/articles");
                if (!response.ok) {
                    console.log(`Failed to fetch articles: ${response.status} ${response.statusText}`);
                }
                const data = await response.json();

                if (!data || !data.data) {
                    console.error("API response:", data);
                    console.log("Invalid API response structure");
                }

                window.sessionStorage.setItem("newsList", JSON.stringify(data.data));
                setArticles(data.data);
            } catch (err) {
                console.error(err);
            }
        };

        const newsList = window.sessionStorage.getItem("newsList");
        if (newsList) {
            setArticles(JSON.parse(newsList));
        } else {
            fetchArticlesFromAPI();
        }
    }, []);

    return articles;
}

const fetchArticleFromAPI = async (url, key, setArticle) => {
    try {
        const response = await fetch(API_URL + url + key);

        if (!response.ok) {
            console.log("Failed to fetch article");
        }

        const data = await response.json();

        if (!data || !data.data) {
            console.log("Invalid API response structure");
        }

        let newsContent = window.sessionStorage.getItem("newsContent");
        newsContent = newsContent ? JSON.parse(newsContent) : {};

        newsContent[key] = data.data;
        window.sessionStorage.setItem("newsContent", JSON.stringify(newsContent));

        setArticle(data.data);
    } catch (err) {
        console.error(err);
    }
}

const fetchArticleFromSessionStorage = (key, setArticle) => {
    let newsList = window.sessionStorage.getItem("newsContent");
    if (newsList) {
        newsList = JSON.parse(newsList);

        const article = newsList[key];
        if (article) {
            setArticle(article);
            return true;
        }
    }
    return false;
};

const useArticle = (slug) => {
    const [article, setArticle] = useState(null);

    useEffect(() => {
        if (!slug) {
            return;
        }

        if (!fetchArticleFromSessionStorage(slug, setArticle)) {
            fetchArticleFromAPI('/article/', slug, setArticle);
        }
    }, [slug]);

    return article;
}

const useArticleByID = (id) => {
    const [article, setArticle] = useState(null);

    useEffect(() => {
        if (!id) {
            return;
        }

        if (!fetchArticleFromSessionStorage(id, setArticle)) {
            fetchArticleFromAPI("/article/id/", id, setArticle);
        }
    }, [id]);

    return article;
}

export {useArticles, useArticleByID, useArticle};